/**
 * External dependencies
 */
import React, { useMemo } from "react";
import { useRouter } from "next/router";

/**
 * Internal dependencies
 */
import { getSlug } from "utils";

const useFaqsThemeSlug = (current: any, app: boolean) => {
  const router = useRouter();
  const hreflangs = useMemo(() => {
    const handlePath = (slug: string, theme: any) =>
      router.pathname.replace("[slug]", slug).replace("[theme]", theme);
    let locales: any = [];
    
    current.attributes.localizations.data?.map((local: any) => {
      if(app) {
        local.attributes.apps.data?.map(({attributes}:any) => {
          locales.push({
            locale: local.attributes.locale.toLowerCase(),
            path: `${handlePath(
              getSlug(local.attributes),
              getSlug(attributes)
            )}`,
          })
        })
      } else {
        local.attributes.themes.data?.map(({attributes}:any) => {
          locales.push({
            locale: local.attributes.locale.toLowerCase(),
            path: `${handlePath(
              getSlug(local.attributes),
              getSlug(attributes)
            )}`,
          })
        })
      }
      
    });

    return [
      {
        locale: current.attributes.locale.toLowerCase(),
        path: `${handlePath(
          getSlug(current.attributes),
          router.query.theme
        )}`,
      },
      ...locales,
    ];
  }, [current]);

  return hreflangs;
};

export default useFaqsThemeSlug;
